import { AUTO_RETRY_BASE_DELAY_MS, AUTO_RETRY_MAX_DELAY_MS } from '#layers/base/constants/auto-retry';

/**
 * How long to wait before the given attempt: exponential backoff with equal jitter, so half the
 * window is a fixed floor and the other half is random. The floor spaces the retry from the failure;
 * the random half keeps clients that went down in the same outage from returning in lockstep.
 *
 * The window stops doubling at `AUTO_RETRY_MAX_DELAY_MS`, which a long outage reaches: `Math.min`
 * also catches the `Infinity` the doubling produces once the attempt count grows.
 *
 * @param attempt - 1-based attempt number
 * @returns Delay in milliseconds
 */
export function getRetryDelay(attempt: number): number {
	const window = Math.min(AUTO_RETRY_BASE_DELAY_MS * 2 ** (attempt - 1), AUTO_RETRY_MAX_DELAY_MS);

	return window / 2 + Math.random() * (window / 2);
}
